var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowEllipse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.75016 11.0833L9.56683 10.2667L8.546 9.21667C9.79044 9.05139 10.8161 8.71111 11.6231 8.19583C12.43 7.68056 12.8335 7.0875 12.8335 6.41667C12.8335 5.60972 12.272 4.92188 11.1491 4.35312C10.0262 3.78437 8.64322 3.5 7.00016 3.5C5.35711 3.5 3.97412 3.78437 2.8512 4.35312C1.72829 4.92188 1.16683 5.60972 1.16683 6.41667C1.16683 7.01944 1.49009 7.55903 2.13662 8.03542C2.78315 8.51181 3.62655 8.86667 4.66683 9.1V7.90417C3.91822 7.70972 3.34218 7.4691 2.93871 7.18229C2.53523 6.89549 2.3335 6.64028 2.3335 6.41667C2.3335 6.10556 2.74912 5.73611 3.58037 5.30833C4.41162 4.88056 5.55155 4.66667 7.00016 4.66667C8.44877 4.66667 9.5887 4.88056 10.42 5.30833C11.2512 5.73611 11.6668 6.10556 11.6668 6.41667C11.6668 6.65 11.4189 6.92951 10.9231 7.25521C10.4272 7.5809 9.72239 7.82639 8.8085 7.99167L9.56683 7.23333L8.75016 6.41667L6.41683 8.75L8.75016 11.0833Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowEllipse);
export default __webpack_public_path__ + "static/media/ArrowEllipse.5dbf1b1c3f969017ebd63944f7829178.svg";
export { ForwardRef as ReactComponent };